import "./Display.css";

const Contact = () => {
  return (
    <div className="platformContainer">
      <h1 className="pageHeading">Contact</h1>
      <p>
          If you want to provide contact or other general information, you can provide me with the text and I will insert.
      </p>
    </div>
  );
};

export default Contact;
